import React, { ReactNode } from 'react';

import ContainerTwoColumns from '@/components/Containers/ContainerTwoColumns';
import Section from '@/components/Sections/Section';

interface Props {
  children: ReactNode;
  id?: string;
  number?: React.ReactElement<SVGElement>;
  noPaddingBottom?: boolean;
}

const DynamicPageContainer = ({ id, number, children, noPaddingBottom }: Props) => (
  <Section id={id} hasVerticalLine noPaddingBottom={noPaddingBottom}>
    <ContainerTwoColumns leftContent={number} rightContent={children} />
  </Section>
);

export default DynamicPageContainer;
